import _slicedToArray from "D:/WebBuild/teamCity/buildAgent/work/f0b2174a44415a20/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _regenerator from "D:/WebBuild/teamCity/buildAgent/work/f0b2174a44415a20/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _toConsumableArray from "D:/WebBuild/teamCity/buildAgent/work/f0b2174a44415a20/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _asyncToGenerator from "D:/WebBuild/teamCity/buildAgent/work/f0b2174a44415a20/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectSpread from "D:/WebBuild/teamCity/buildAgent/work/f0b2174a44415a20/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.iterator.some.js";
import "core-js/modules/es.json.parse.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.number.to-fixed.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.test.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.pad-start.js";
import CustomTable from '@/components/correspondence/custom-table';
import { getDetail as _getDetail } from '@/api/setting/task/create';
import { batchDelData, batchFlow, updateECodeStatus, uploadJsonData as _uploadJsonData } from '@/api/correspondence/task/form';
import { createObjectURL, transformFilterComponentDataV2 } from '@/util';
import SetGetStaff from './setGetStaff';
import { customDownloadList, customHistoryDownloadList } from '@/api/correspondence/task';
import { mapState } from 'vuex';
import { json2excel } from '@/util/json2excel';
import { dateToCNByDayJs } from '@/filters';
import BaseForm from '@/views/correspondence/task/components/form.vue';
import PrintCode from '@/views/correspondence/task/components/components/print-code';
export default {
  name: 'correspondence-control',
  props: {
    canBeCreate: {
      default: function _default() {
        return true;
      }
    },
    admin: {
      default: function _default() {
        return false;
      }
    },
    importTemplate: {
      default: function _default() {
        return false;
      }
    },
    id: {},
    history: {
      default: function _default() {
        return false;
      }
    }
  },
  components: {
    CustomTable: CustomTable,
    BaseForm: BaseForm
  },
  computed: _objectSpread(_objectSpread({}, mapState('cpscc', ['userInfo'])), {}, {
    correspondenceType: function correspondenceType() {
      return this.$store.state.cpscc.correspondenceType;
    },
    isSender: function isSender() {
      if (this.userInfo && this.userInfo.data2) {
        if (Array.isArray(this.userInfo.data2.roles)) {
          return this.userInfo.data2.roles.includes('发函操作员');
        }
      }
      return false;
    },
    isreplyPersonnel: function isreplyPersonnel() {
      if (this.userInfo && this.userInfo.data2) {
        if (Array.isArray(this.userInfo.data2.roles)) {
          return this.userInfo.data2.roles.includes('回函操作员');
        }
      }
      return false;
    },
    userId: function userId() {
      if (this.userInfo && this.userInfo.data2) {
        return this.userInfo.data2.userId;
      }
      return undefined;
    },
    isCpscAdmin: function isCpscAdmin() {
      if (this.userInfo && this.userInfo.data2) {
        if (Array.isArray(this.userInfo.data2.roles)) {
          return this.userInfo.data2.roles.includes('函证中心管理员');
        }
      }
      return false;
    },
    isManager: function isManager() {
      return this.roles.includes('经理') || this.roles.includes('现场负责人') || this.roles.includes('合伙人');
    },
    searchQuery: function searchQuery() {
      var searchParams = this.searchParams;
      var searchParamList = [];
      var str = '';
      for (var key in searchParams) {
        if (searchParams.hasOwnProperty(key) && searchParams[key] !== undefined && searchParams[key] !== '') {
          searchParamList.push("".concat(key, ".contains(\"").concat(searchParams[key], "\")"));
        }
      }
      if (searchParamList.length > 0) {
        str = searchParamList.join(' and ');
      }
      if (this.filterCodeParams) {
        if (str) {
          str = "".concat(str, " and ").concat(this.filterCodeParams);
        } else {
          str = this.filterCodeParams;
        }
      }
      if (this.searchOtherParam && this.searchOtherParam.value) {
        str += "".concat(this.searchOtherParam.value);
      }
      return str;
    },
    _batchHandleList: function _batchHandleList() {
      var _this = this;
      var list = JSON.parse(JSON.stringify(this.batchHandleList));
      if (this.$route.meta.isCpscAdmin) {
        list = list.filter(function (item) {
          return item.key === 'send' || item.key === 'receive';
        });
        list.push({
          text: '领取函证',
          key: 'batchUpdateGetStaff',
          disabled: false
        });
      } else {
        var _list;
        (_list = list).push.apply(_list, [{
          text: '审核',
          key: 'approve',
          disabled: !this.isManager
        }, {
          text: '拒绝',
          key: 'reject',
          disabled: !this.isManager
        }, {
          text: '删除',
          key: 'del',
          disabled: false
        }]);
      }
      var filterValue = this.filterValue;
      list = list.map(function (item) {
        if (filterValue) {
          if (_this.filterValue === '草稿') {
            if (item.text === '置为作废' || item.text === '置为待审') {
              return _objectSpread(_objectSpread({}, item), {}, {
                disabled: false
              });
            }
          } else if (_this.filterValue === '待审核') {
            if (item.text === '置为草稿' || item.text === '置为作废') {
              return _objectSpread(_objectSpread({}, item), {}, {
                disabled: false
              });
            } else if (item.text === '审核' || item.text === '拒绝') {
              return item;
            }
          } else if (_this.filterValue === '已审核') {
            if (item.text === '置为已发函' || item.text === '置为作废' || item.text === '置为草稿' || item.text === '打印') {
              return _objectSpread(_objectSpread({}, item), {}, {
                disabled: false
              });
            }
          } else if (_this.filterValue === '已发函') {
            if (item.text === '置为已回函' || item.text === '置为作废') {
              return _objectSpread(_objectSpread({}, item), {}, {
                disabled: false
              });
            }
          } else if (_this.filterValue === '已回函') {
            if (item.text === '置为作废' || item.text === '领取函证') {
              return _objectSpread(_objectSpread({}, item), {}, {
                disabled: false
              });
            }
          }
          return _objectSpread(_objectSpread({}, item), {}, {
            disabled: true
          });
        } else {
          if (item.text === '删除') {
            return _objectSpread(_objectSpread({}, item), {}, {
              disabled: false
            });
          }
        }
        return _objectSpread(_objectSpread({}, item), {}, {
          disabled: true
        });
      });
      if (this.isSender || this.isreplyPersonnel) {
        list = list.filter(function (item) {
          if (_this.isSender && item.key === 'send') {
            return true;
          }
          if (_this.isreplyPersonnel && item.key === 'receive') {
            return true;
          }
          return false;
        });
      }
      return list;
    },
    _filterData: function _filterData() {
      var _this2 = this;
      var list = this.filterData.map(function (item) {
        if (item.value === '待审核') {
          return _objectSpread(_objectSpread({}, item), {}, {
            disabled: !_this2.isManager
          });
        }
        return item;
      });
      if (this.isSender) {
        list = list.filter(function (item) {
          if (_this2.isSender && item.value === '已审核') {
            return true;
          }
          // if (this.isreplyPersonnel && (item.value === '已发函' || item.value === '已回函')) {
          //   return true
          // }
          return false;
        });
      }
      if (this.isCpscAdmin || this.isreplyPersonnel) {
        list.splice(6, 0, {
          name: '已回且地址为空',
          value: '已回且地址为空',
          other: {
            value: ' and string.isnullorwhitespace(c02SendRecAddress) and c02SendType.contains("邮寄发函")'
          }
        });
        list.splice(6, 0, {
          name: '已发且地址为空(超过40天)',
          value: '已发且地址为空',
          other: {
            value: " and string.isnullorwhitespace(c02SendRecAddress) and c02SendType.contains(\"\u90AE\u5BC4\u53D1\u51FD\") and c02SendDate < \"".concat(this.getDate50DaysAgo(40), "\"  and c02SendDate > \"").concat(this.getDate50DaysAgo(100), "\"")
          }
        });
      }
      return list;
    }
  }),
  data: function data() {
    return {
      downloadExcelModel: {
        date: undefined,
        type: undefined,
        show: false
      },
      stateValue: '',
      showDrawer: false,
      formInfo: {
        id: undefined,
        uid: undefined
      },
      filterItemList: [{
        input: true,
        inputType: 'text',
        label: '函证对象名称',
        Symbol: 'contains',
        value: 'c03CusName'
      }],
      filterData: [{
        name: '全部',
        value: ''
      }, {
        name: '草稿',
        value: '草稿'
      }, {
        name: '待审核',
        value: '待审核',
        params: {
          pendingApprovalOnly: true
        }
      }, {
        name: '已审核',
        value: '已审核'
      }, {
        name: '已发函',
        value: '已发函'
      }, {
        name: '已回函',
        value: '已回函'
      }, {
        name: '已作废',
        value: '作废'
      }
      // {
      //   name:'已回函+未领取',
      //   value:'6'
      // },
      ],
      info: {},
      template: null,
      filterKey: undefined,
      filterValue: undefined,
      searchOtherParam: undefined,
      batchHandleList: [{
        text: '置为草稿',
        key: 'revoke'
      }, {
        text: '置为待审',
        key: 'submit'
      }, {
        text: '置为已发函',
        key: 'send'
      }, {
        text: '置为已回函',
        key: 'receive'
      }, {
        text: '置为作废',
        key: 'disable'
      },
      // {
      //   text:'审核',
      //   key:'approve'
      // },
      // {
      //   text:'拒绝',
      //   key:'reject'
      // },
      {
        text: '打印',
        key: 'print'
      }],
      selectedList: [],
      loading: false,
      filterListParams: undefined,
      roles: [],
      uploading: false,
      searchKey: undefined,
      searchParams: {
        c02ConfirmCode: undefined,
        c02Status: undefined
      },
      filterCodeParams: undefined
    };
  },
  methods: {
    getDate50DaysAgo: function getDate50DaysAgo() {
      var days = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 50;
      // 1. 获取当前日期
      var currentDate = new Date();

      // 2. 复制当前日期对象（避免修改原始对象）
      var pastDate = new Date(currentDate);

      // 3. 减去 50 天
      pastDate.setDate(pastDate.getDate() - days);

      // 4. 格式化为 YYYY-MM-DD 字符串
      var year = pastDate.getFullYear();
      var month = String(pastDate.getMonth() + 1).padStart(2, '0'); // 月份从0开始需+1
      var day = String(pastDate.getDate()).padStart(2, '0');
      return "".concat(year, "-").concat(month, "-").concat(day);
    },
    exportExcel: function exportExcel() {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var list, columns, data;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              list = _this3.$refs.table.dataList;
              if (!(list.length === 0)) {
                _context.n = 1;
                break;
              }
              return _context.a(2, _this3.$message.warning('没有数据'));
            case 1:
              columns = ['函证编码', '函证对象名称', '作业客户名', '被审单位', '函证类型', '截止日期', '创建日期', '发函次数', '回函方式', '回函日期', '回函初判', '地址初判', '函证结论', '领取状态', '回函快递单号', '回函操作人', '回函操作日期', '函证状态', '领取人', '领取日期', '币码函证状态'];
              data = list.map(function (item) {
                return [item.c02ConfirmCode, item.c03CusName, item.c01task ? item.c01task.c01CusName : '', item.c02AuditCompany, item.c02Type, _this3.$options.filters.date(item.c02Perior, 'yyyy-MM-dd'), _this3.$options.filters.date(item.c02CreateDate, 'yyyy-MM-dd'), item.c02SendFrequency ? "\u5DF2\u53D1".concat(item.c02SendFrequency, "\u6B21") : '', item.c02BackType, _this3.$options.filters.date(item.c02BackConfirmDate, 'yyyy-MM-dd'), item.c02BackConfirmValid, item.c02BackAddressStatus, item.c02BackConfirmConclusion, item.c02GetStatus, item.c02BackNumber, item.c02BackConfirmName, _this3.$options.filters.date(item.c02BackConfirmOperateDate, 'yyyy-MM-dd'), "".concat(item.c02Status).concat(item.c02GetStatus === '已领取' ? '(已领取)' : ''), "".concat(item.c02GetStatus === '已领取' ? "".concat(item.c02GetStaff) : ''), "".concat(item.c02GetStatus === '已领取' ? "".concat(_this3.transformDate(item.c02GetDate)) : ''), "".concat(item.c02SendType === '电子函证' && item.c02Extended ? item.c02Extended.currentProgress : '')];
              });
              json2excel([columns].concat(_toConsumableArray(data)));
            case 2:
              return _context.a(2);
          }
        }, _callee);
      }))();
    },
    transformDate: function transformDate(date) {
      return dateToCNByDayJs(date, 'YYYY-MM-DD');
    },
    getFilterCode: function getFilterCode(combineSearch) {
      var _this4 = this;
      var params = combineSearch.form;
      var type = {
        all: 'and',
        or: 'or'
      };
      this.filterCodeParams = transformFilterComponentDataV2(params, type[combineSearch.type]);
      this.$nextTick(function () {
        _this4.$refs.table.handleCurrentChange(1);
      });
    },
    codeChange: function codeChange() {
      var _this5 = this;
      var reg = /^(h|H)\w{12}/g;
      var reg2 = /^\w{12}/g;
      if (reg.test(this.searchKey) || reg2.test(this.searchKey)) {
        this.searchParams.c02ConfirmCode = this.searchKey.slice(1);
        this.$nextTick(function () {
          _this5.$refs.table.handleCurrentChange(1, {
            toDetail: true
          });
          _this5.searchKey = undefined;
        });
      }
    },
    searchList: function searchList() {
      var _this6 = this;
      this.searchParams.c02ConfirmCode = this.searchKey;
      this.$nextTick(function () {
        _this6.$refs.table.handleCurrentChange(1);
      });
    },
    uploadJsonData: function uploadJsonData(json) {
      var _this7 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var _yield$_this7$$awaitT, _yield$_this7$$awaitT2, err, data;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _this7.uploading = true;
              _context2.n = 1;
              return _this7.$awaitTo(_uploadJsonData(_this7.id, json));
            case 1:
              _yield$_this7$$awaitT = _context2.v;
              _yield$_this7$$awaitT2 = _slicedToArray(_yield$_this7$$awaitT, 2);
              err = _yield$_this7$$awaitT2[0];
              data = _yield$_this7$$awaitT2[1];
              _this7.uploading = false;
              if (!err) {
                _context2.n = 2;
                break;
              }
              return _context2.a(2);
            case 2:
              _this7.$message.success(data);
              _this7.$refs.table.handleCurrentChange(1);
            case 3:
              return _context2.a(2);
          }
        }, _callee2);
      }))();
    },
    fileChange: function fileChange(files) {
      if (files && files.length) {
        var file = files[0];
        var render = new FileReader();
        var self = this;
        render.onload = function (evt) {
          var content = evt.target.result;
          self.uploadJsonData(content);
        };
        var blob = file.slice(0, file.size);
        render.readAsText(blob, 'utf-8');
      }
    },
    getSelectedList: function getSelectedList(arr) {
      this.selectedList = arr;
    },
    PrintCorrespondence: function PrintCorrespondence() {
      var _this8 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var _this8$$router$resolv, href;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              window.sessionStorage.setItem('updatePrintQueue', JSON.stringify(_this8.selectedList));
              _this8$$router$resolv = _this8.$router.resolve({
                name: 'print-queue'
              }), href = _this8$$router$resolv.href;
              window.open(href, '_blank');
            case 1:
              return _context3.a(2);
          }
        }, _callee3);
      }))();
    },
    batchHandle: function batchHandle(command) {
      var _this9 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        var res, list, r, statusr, _list2, _r, _yield$_this9$$awaitT, _yield$_this9$$awaitT2, err, data, _list3, _yield$_this9$$awaitT3, _yield$_this9$$awaitT4, _err, text, _list4, _res, _yield$_this9$$awaitT5, _yield$_this9$$awaitT6, _err2, _text, electronicLetters, status, notify, _yield$_this9$$awaitT7, _yield$_this9$$awaitT8, _err3;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              res = _this9._batchHandleList.find(function (item) {
                return item.key === command;
              });
              if (!res) {
                _context4.n = 19;
                break;
              }
              if (!(res.key === 'print')) {
                _context4.n = 3;
                break;
              }
              list = _this9.selectedList;
              r = list.some(function (sub) {
                return (sub.c02Confirm === '' || sub.c02Confirm === undefined) && (sub.c02SendFile1 === '' || sub.c02SendFile1 === undefined);
              });
              if (!r) {
                _context4.n = 1;
                break;
              }
              _this9.$message.warning('所选函证中存在内容为空');
              return _context4.a(2);
            case 1:
              statusr = list.some(function (sub) {
                return sub.c02Status === '草稿' || sub.c02Status === '待审核' || sub.c02Status === '作废';
              });
              if (!statusr) {
                _context4.n = 2;
                break;
              }
              _this9.$message.warning('所选函证中存在 草稿/待审核/作废 状态');
              return _context4.a(2);
            case 2:
              _this9.PrintCorrespondence();
              _context4.n = 19;
              break;
            case 3:
              if (!(res.key === 'batchUpdateGetStaff')) {
                _context4.n = 7;
                break;
              }
              _list2 = _this9.selectedList;
              _r = _list2.some(function (sub) {
                return sub.c02Status !== '已回函';
              });
              if (!_r) {
                _context4.n = 4;
                break;
              }
              _this9.$message.warning('所选函证中存在非回函状态');
              return _context4.a(2);
            case 4:
              _context4.n = 5;
              return _this9.$awaitTo(_this9.$dialog(SetGetStaff, {
                dialog: {
                  title: '批量领取',
                  width: '400px'
                },
                props: {
                  ids: _this9.selectedList.map(function (item) {
                    return item.c02Id;
                  })
                }
              }, function (template) {
                _this9.template = template;
              }));
            case 5:
              _yield$_this9$$awaitT = _context4.v;
              _yield$_this9$$awaitT2 = _slicedToArray(_yield$_this9$$awaitT, 2);
              err = _yield$_this9$$awaitT2[0];
              data = _yield$_this9$$awaitT2[1];
              _this9.template = null;
              if (!err) {
                _context4.n = 6;
                break;
              }
              return _context4.a(2);
            case 6:
              _this9.selectedList = [];
              _this9.$refs.table.handleCurrentChange(1);
              _context4.n = 19;
              break;
            case 7:
              if (!(res.key === 'del')) {
                _context4.n = 12;
                break;
              }
              _list3 = _this9.selectedList;
              if (!(_list3.length === 0)) {
                _context4.n = 8;
                break;
              }
              _this9.$message.warning('不符合删除条件,必须是本人创建+草稿状态+不含函证编码');
              return _context4.a(2);
            case 8:
              _context4.n = 9;
              return _this9.$confirm("\u786E\u5B9A\u5220\u9664?\u672C\u6B21\u7B26\u5408\u5220\u9664\u6761\u4EF6\u6709".concat(_list3.length, "\u6761"));
            case 9:
              _this9.loading = true;
              _context4.n = 10;
              return _this9.$awaitTo(batchDelData(_this9.id, _list3.map(function (item) {
                return item.c02Id;
              })));
            case 10:
              _yield$_this9$$awaitT3 = _context4.v;
              _yield$_this9$$awaitT4 = _slicedToArray(_yield$_this9$$awaitT3, 2);
              _err = _yield$_this9$$awaitT4[0];
              text = _yield$_this9$$awaitT4[1];
              _this9.loading = false;
              if (!_err) {
                _context4.n = 11;
                break;
              }
              return _context4.a(2);
            case 11:
              _this9.selectedList = [];
              _this9.$message.success(text);
              _this9.$refs.table.handleCurrentChange(1);
              _context4.n = 19;
              break;
            case 12:
              _list4 = _this9.selectedList;
              if (!(res.key === 'approve' || res.key === 'reject')) {
                _context4.n = 13;
                break;
              }
              _res = _list4.some(function (sub) {
                return sub.c02Status !== '待审核';
              });
              if (!_res) {
                _context4.n = 13;
                break;
              }
              _this9.$message.warning('所选函证中存在非待审状态');
              return _context4.a(2);
            case 13:
              _context4.n = 14;
              return _this9.$confirm("\u786E\u5B9A".concat(res.text, "?"));
            case 14:
              _this9.loading = true;
              _context4.n = 15;
              return _this9.$awaitTo(batchFlow(_this9.id, {
                operation: res.key,
                confirmIds: _list4.map(function (item) {
                  return item.c02Id;
                })
              }));
            case 15:
              _yield$_this9$$awaitT5 = _context4.v;
              _yield$_this9$$awaitT6 = _slicedToArray(_yield$_this9$$awaitT5, 2);
              _err2 = _yield$_this9$$awaitT6[0];
              _text = _yield$_this9$$awaitT6[1];
              _this9.loading = false;
              if (!_err2) {
                _context4.n = 16;
                break;
              }
              return _context4.a(2);
            case 16:
              _this9.selectedList = [];
              if (!(command === 'send' || command === 'disable')) {
                _context4.n = 18;
                break;
              }
              electronicLetters = _list4.filter(function (sub) {
                return sub.c02SendType === '电子函证';
              });
              if (!electronicLetters.length) {
                _context4.n = 18;
                break;
              }
              status = {
                send: '重发电子函',
                disable: '作废电子函'
              };
              _this9.loading = true;
              notify = _this9.$notify({
                title: '提示',
                message: '正在向币码同步状态...请不要关闭页面',
                duration: 0
              });
              _context4.n = 17;
              return _this9.$awaitTo(updateECodeStatus(_this9.id, {
                status: status[command],
                confirmCodes: electronicLetters.map(function (item) {
                  return item.c02ConfirmCode;
                })
              }));
            case 17:
              _yield$_this9$$awaitT7 = _context4.v;
              _yield$_this9$$awaitT8 = _slicedToArray(_yield$_this9$$awaitT7, 1);
              _err3 = _yield$_this9$$awaitT8[0];
              notify.close();
              _this9.loading = false;
              if (!_err3) {
                _context4.n = 18;
                break;
              }
              return _context4.a(2);
            case 18:
              _this9.$message.success(_text);
              _this9.$refs.table.handleCurrentChange(1);
            case 19:
              return _context4.a(2);
          }
        }, _callee4);
      }))();
    },
    changeStatus: function changeStatus(_ref) {
      var _this0 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
        var value, params, other, v;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              value = _ref.value, params = _ref.params, other = _ref.other;
              v = value;
              if (v === '已回且地址为空') {
                v = '已回函';
              } else if (v === '已发且地址为空') {
                v = '已发函';
              }
              _this0.searchParams.c02Status = v;
              _this0.searchOtherParam = other || undefined;
              _this0.filterValue = v;
              _this0.$nextTick(function () {
                _this0.$refs.table.handleCurrentChange(1, params);
              });
            case 1:
              return _context5.a(2);
          }
        }, _callee5);
      }))();
    },
    toPrintBarcode: function toPrintBarcode() {
      var _this1 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6() {
        var _yield$_this1$$awaitT, _yield$_this1$$awaitT2, err, data;
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.n) {
            case 0:
              _context6.n = 1;
              return _this1.$awaitTo(_this1.$dialog(PrintCode, {
                dialog: {
                  title: '打印函证编码',
                  width: '300px',
                  appendToBody: true,
                  modalAppendToBody: true
                },
                props: {
                  codes: _this1.selectedList.map(function (item) {
                    return item.c02ConfirmCode;
                  })
                }
              }, function (template) {
                _this1.template = template;
              }));
            case 1:
              _yield$_this1$$awaitT = _context6.v;
              _yield$_this1$$awaitT2 = _slicedToArray(_yield$_this1$$awaitT, 2);
              err = _yield$_this1$$awaitT2[0];
              data = _yield$_this1$$awaitT2[1];
              _this1.template = null;
            case 2:
              return _context6.a(2);
          }
        }, _callee6);
      }))();
    },
    exportFile: function exportFile() {
      var _this10 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7() {
        var _yield$_this10$$await, _yield$_this10$$await2, err, data, self, reader;
        return _regenerator().w(function (_context7) {
          while (1) switch (_context7.n) {
            case 0:
              _context7.n = 1;
              return _this10.$awaitTo(_this10.history ? customHistoryDownloadList(_this10.selectedList.map(function (item) {
                return item.c02Id;
              })) : customDownloadList(_this10.selectedList.map(function (item) {
                return item.c02Id;
              })));
            case 1:
              _yield$_this10$$await = _context7.v;
              _yield$_this10$$await2 = _slicedToArray(_yield$_this10$$await, 2);
              err = _yield$_this10$$await2[0];
              data = _yield$_this10$$await2[1].data;
              if (!err) {
                _context7.n = 2;
                break;
              }
              return _context7.a(2);
            case 2:
              self = _this10;
              if (data.type === 'application/zip-x-compressed') {
                createObjectURL(data, "".concat(_this10.info.c01TaskCode, ".zip"));
              } else {
                reader = new FileReader();
                reader.addEventListener('loadend', function () {
                  //
                  self.$message.error(this.result);
                });
                reader.readAsText(data, 'utf-8');
              }
            case 3:
              return _context7.a(2);
          }
        }, _callee7);
      }))();
    },
    getDetail: function getDetail() {
      var _this11 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee8() {
        var _yield$_this11$$await, _yield$_this11$$await2, err, data;
        return _regenerator().w(function (_context8) {
          while (1) switch (_context8.n) {
            case 0:
              _this11.loading = true;
              _context8.n = 1;
              return _this11.$awaitTo(_getDetail({
                TaskId: _this11.id
              }));
            case 1:
              _yield$_this11$$await = _context8.v;
              _yield$_this11$$await2 = _slicedToArray(_yield$_this11$$await, 2);
              err = _yield$_this11$$await2[0];
              data = _yield$_this11$$await2[1];
              _this11.loading = false;
              if (!err) {
                _context8.n = 2;
                break;
              }
              return _context8.a(2);
            case 2:
              // let form = data.data1.taskInfo;
              if (data.data1) {
                _this11.info = data.data1.taskInfo;
              }
              if (data.data2) {
                _this11.roles = data.data2.roles;
              }
            case 3:
              return _context8.a(2);
          }
        }, _callee8);
      }))();
    },
    km: function km(val) {
      if (!val) {
        return '0(m)';
      }
      if (val >= 0 && val < 1000) {
        return "".concat(val, "(m)");
      }
      return "".concat((val / 1000).toFixed(2), "(km)");
    },
    downloadExcel: function downloadExcel() {
      var _this12 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee9() {
        var _yield$_this12$$await, _yield$_this12$$await2, err, data, excelHeader, tableData, excelData;
        return _regenerator().w(function (_context9) {
          while (1) switch (_context9.n) {
            case 0:
              _this12.loading = true;
              _context9.n = 1;
              return _this12.$awaitTo(toExport2Excel(_this12.id, {
                confirmType: _this12.downloadExcelModel.type,
                period: _this12.downloadExcelModel.date
              }));
            case 1:
              _yield$_this12$$await = _context9.v;
              _yield$_this12$$await2 = _slicedToArray(_yield$_this12$$await, 2);
              err = _yield$_this12$$await2[0];
              data = _yield$_this12$$await2[1];
              _this12.loading = false;
              if (!err) {
                _context9.n = 2;
                break;
              }
              return _context9.a(2);
            case 2:
              _this12.loading = true;
              excelHeader = [['函证状态', '函证编号', '函证对象全称(企业/个人)', '所属子公司', '截止日期', '样本类型', '函证类型', '被函证对象发函地址', '函证收件人', '收件人联系电话', '收件人备用电话', '收件人职位', '工商注册地址', '距离', '地址核对结论', '核对过程说明', '发函方式', '发函快递公司', '发函邮寄单号', '发函/跟函人', '发函/跟函日期', '发函/跟函地点', '发函/跟函过程描述', '回函方式', '回函快递公司', '回函邮寄单号', '回函发出地址', '回函人', '回函签收日期', '回函函证状态', '回函函证结论', '回函地址核验', '地址距离', '项目组-地址异常检查说明', '项目组-函证异常/结论不符检查说明']];
              tableData = data.map(function (item) {
                var confirmation = item;
                return [confirmation.c02Status, confirmation.c02ConfirmCode, "".concat(confirmation.c03CusName).concat(confirmation.c03CusType ? "(".concat(confirmation.c03CusType, ")") : ''), confirmation.c02AuditCompany, confirmation.c02Perior, confirmation.c02SampleType, confirmation.c02Type, confirmation.c02ObjAddress, confirmation.c02ObjStaff, confirmation.c02ObjMobile, confirmation.c02ObjTel, confirmation.c02ObjPosition, confirmation.c03CorrectAddress, _this12.km(confirmation.c02CheckDistance), confirmation.c02CheckConclusion, confirmation.c02CheckProcess, confirmation.c02SendType, confirmation.c02SendCompany, confirmation.c02SendNumber, confirmation.c02SendStaff, _this12.$options.filters.date(confirmation.c02SendDate, 'yyyy-MM-dd'), confirmation.c02SendAddress, confirmation.c02SendProcess, confirmation.c02BackType, confirmation.c02BackCompany, confirmation.c02BackNumber, confirmation.c02BackAddress, confirmation.c02BackSendName, _this12.$options.filters.date(confirmation.c02BackConfirmActualDate, 'yyyy-MM-dd'), confirmation.c02BackConfirmValid, confirmation.c02BackConfirmConclusion, confirmation.c02BackAddressCheck, _this12.km(confirmation.c02BackAddressDistance), confirmation.c02BackAddressFllow, confirmation.c02BackAddressReStatus];
              });
              excelData = [].concat(excelHeader, _toConsumableArray(tableData));
              json2excel(excelData, "".concat(_this12.info.c01TaskCode, "-").concat(_this12.info.c01CusName, ".xlsx"));
              _this12.loading = false;
            case 3:
              return _context9.a(2);
          }
        }, _callee9);
      }))();
    },
    create: function create() {
      var _this13 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee0() {
        return _regenerator().w(function (_context0) {
          while (1) switch (_context0.n) {
            case 0:
              _this13.$router.push("/correspondence/task/form/".concat(_this13.id));
              // this.formInfo.id = this.id
              // await this.$nextTick()
              // this.showDrawer = true
            case 1:
              return _context0.a(2);
          }
        }, _callee0);
      }))();
    }
  },
  created: function created() {
    if (this.id) {
      this.getDetail();
    }
    // if (this.isSender) {
    //   this.changeStatus({ value: '已审核' })
    // }
    // if (this.isreplyPersonnel) {
    //   this.changeStatus({ value: '已发函' })
    // }
  }
};